import { evacuationEntryDTOSchema, evacuationHostAlertDTOSchema, evacuationRosterDTOSchema, } from '@instanexus/contracts';
import { dataEnvelopeSchema, WEB_API_PREFIX } from '../transport.js';
const rosterSchema = dataEnvelopeSchema(evacuationRosterDTOSchema);
const entrySchema = dataEnvelopeSchema(evacuationEntryDTOSchema);
const alertSchema = dataEnvelopeSchema(evacuationHostAlertDTOSchema);
export function createEvacuationResource(transport) {
    return {
        async roster(query) {
            const envelope = await transport.request({
                path: `${WEB_API_PREFIX}/evacuation/roster`,
                schema: rosterSchema,
                query: { locationId: query?.locationId },
            });
            return envelope.data;
        },
        async markSafe(visitId) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/visits/${encodeURIComponent(visitId)}/mark-safe`,
                schema: entrySchema,
            });
            return envelope.data;
        },
        async exportCsv(query) {
            return transport.requestText({
                path: `${WEB_API_PREFIX}/evacuation/export`,
                accept: 'text/csv',
                query: { locationId: query?.locationId },
            });
        },
        async alertHosts(input) {
            const envelope = await transport.request({
                method: 'POST',
                path: `${WEB_API_PREFIX}/evacuation/alert-hosts`,
                body: input,
                schema: alertSchema,
            });
            return envelope.data;
        },
    };
}
//# sourceMappingURL=evacuation.js.map